module.exports = __webpack_public_path__ + "static/media/slider-l2.9517635d.webp";